<template>
    <div class="action-updated-profile">
        <div class="title f-bold" v-html="$translate('ACTION_UPDATED_PROFILE')" />
        <div class="body">
            <div v-html="body" />
        </div>
    </div>
</template>
<script>
export default {
    name: 'ActionUpdatedProfile',
    props: ['message'],
    computed: {
        chat() {
            return this.$store.getters.chat
        },
        chatUser() {
            if (!this.chat) return

            return (this.chat || {}).user
        },
        body() {
            const body = this.$translate('ACTION_UPDATED_PROFILE_BODY')
            return body
            // return body.replace(/%s/, this.$nameOrNick(this.chatUser))
        },
    },
}
</script>
